import { dataHooks } from '../../../../libs/dataHooks';

export const colorsFilterDataHooks = dataHooks<{
  filterItem: { id: string };
}>('color-filters');
